import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { IFeaturedColumns } from '../../types';
import { StoreInfoColumn } from '../../components/store-info-column';
import * as S from '../styles';
import { StockPriceInfo } from '../../components/stock-price-info';
import Clickable from '@prisjakt/ui-clickable';
import { GoToStoreButton } from '../../components/go-to-store-button';
import { getContainerProps } from '../../utils';

export const FeaturedColumns: React.FC<IFeaturedColumns> = props => {
  const { tableLinkProps } = props;
  const { offer } = usePriceRowContext();
  const { name, featured } = offer;

  const containerProps = getContainerProps(
    name || '',
    Boolean(featured),
    tableLinkProps.onClick,
    tableLinkProps.href
  );

  return (
    <S.ActionArea container={Clickable} containerProps={containerProps}>
      <S.Content>
        <StoreInfoColumn />
        <S.MiddleColumn featured>
          <S.TopMiddleRow featured={featured}>
            <S.ProductNameColumn featured>
              <S.ProductName featured>{name}</S.ProductName>
            </S.ProductNameColumn>
            <StockPriceInfo />
          </S.TopMiddleRow>
        </S.MiddleColumn>
        <S.EndColumn featured>
          <GoToStoreButton />
        </S.EndColumn>
      </S.Content>
    </S.ActionArea>
  );
};
